<template>
    <SecondLevelTabs
        v-if="secondLevelInfoTabs.length"
        :tabs="secondLevelInfoTabs"
        translation-key="sales_settings_tabs"
    >
        <template v-slot:products>
            <SalesSettingsProductForm v-if="formData?.productTypeEnabled" v-model="formData" />
        </template>
        <template v-slot:calculation>
            <SalesSettingsCalculationForm v-model="formData" />
        </template>
        <template v-slot:service_fees>
            <SalesSettingsServiceFeesForm v-model="formData" />
        </template>
        <template v-slot:vat>
            <SalesSettingsVatForm v-model="formData" />
        </template>
        <template v-slot:sales_terms>
            <SalesSettingsTermsForm v-model="formData" />
        </template>
        <template v-slot:cross_rates>
            <div :class="{'pb-3': !isReadOnly}" class="text-subtitle-1 font-weight-medium">
                {{ $t('cross_rates_title') }}
            </div>
            <div v-if="isReadOnly || contractGroupPlace === 'CONTRACT_GROUP'" class="font-italic pb-5">
                {{ `${$t('set_in_relation_to_current_contract_currency')} (${formData.currency})` }}
            </div>
            <v-row v-for="item in formData.charges" :key="item.currency" no-gutters class="align-center gc-5 mb-4">
                <div>{{ item.currency }} %</div>
                <v-number-input v-model="item.charge" :min="0" hide-details max-width="100" density="compact" />
            </v-row>
        </template>
        <template v-slot:cancellation_fees>
            <SalesSettingsCancellationFeesForm v-model="formData" />
        </template>
        <template v-slot:invoices>
            <SalesSettingsInvoicesForm v-model="formData" />
        </template>
        <template v-slot:grouping>
            <SalesSettingsGroupingForm v-model="formData" />
        </template>
        <template v-slot:loyalty>
            <SalesSettingsLoyaltyForm v-model="formData" />
        </template>
        <template v-slot:tags>
            <SalesSettingsTagsForm v-model="formData" />
        </template>
        <template v-slot:additionally>
            <SalesSettingsAdditionallyForm v-model="formData" />
        </template>
    </SecondLevelTabs>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()

    const secondLevelInfoTabs = ref([])
    const isReadOnly = inject('isReadOnly', ref(false))
    const isTAContract: boolean = inject('isTAContract', false)
    const isShowInvoices: boolean = inject('isShowInvoices', false)
    const isShowAdditionally: boolean = inject('isShowAdditionally', false)
    const contractGroupPlace: string = inject('contractGroupPlace')

    onMounted(async () => {
        secondLevelInfoTabs.value = [
            'products',
            'calculation',
            runtimeStore.getCRMOption('asp.option.enable.service.fee') && 'service_fees',
            runtimeStore.getCRMOption('asp.option.enable.vat') && 'vat',
            'sales_terms',
            'cross_rates',
            'cancellation_fees',
            isShowInvoices && 'invoices',
            runtimeStore.getCRMOption('asp.option.show.tab.grouping') && 'grouping',
            authStore.isTO1 && !isTAContract && runtimeStore.getCRMOption('asp.option.show.loyalty') && 'loyalty',
            runtimeStore.getCRMOption('asp.option.allow.tags') && 'tags',
            isShowAdditionally && 'additionally',
        ].filter(Boolean)
    })

    defineExpose({
        secondLevelInfoTabs,
    })
</script>
